import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { acceptInvitation } from '../services/invitationService';
import Header from '../components/Header';
import { signInWithPopup, OAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';

const AcceptInvitationPage = () => {
  const { invitationId } = useParams();
  const navigate = useNavigate();
  const { currentUser, signInWithGoogle } = useAuth();
  const [invitation, setInvitation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInvitation = async () => {
      try {
        const invitationRef = doc(db, 'invitations', invitationId);
        const invitationDoc = await getDoc(invitationRef);
        
        if (!invitationDoc.exists()) {
          setError('Invitation not found or has expired.');
          return;
        }

        const invitationData = invitationDoc.data();
        if (invitationData.status !== 'pending') {
          setError('This invitation has already been used or canceled.');
          return;
        }

        setInvitation(invitationData);
      } catch (err) {
        console.error('Error fetching invitation:', err);
        setError('Failed to load invitation. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchInvitation();
  }, [invitationId]);

  const handleSignInAndAccept = async (provider = 'google') => {
    try {
      let result;
      if (provider === 'apple') {
        result = await signInWithPopup(auth, new OAuthProvider('apple.com'));
      } else {
        result = await signInWithGoogle();
      }
      
      if (result.user) {
        await acceptInvitation(invitationId);
        navigate('/connect');
      }
    } catch (err) {
      console.error('Error during sign in:', err);
      setError('Failed to sign in. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header user={currentUser} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">Loading...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header user={currentUser} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="text-center text-red-600">{error}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header user={currentUser} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow p-6">
          <h1 className="text-2xl font-semibold text-gray-900 mb-4">
            Accept Invitation
          </h1>
          <p className="mb-6">
            {invitation?.fromUserName || 'Someone'} has invited you to join Going Green Cards!
          </p>
          {!currentUser ? (
            <div>
              <p className="mb-4">Please sign in with Google to accept this invitation.</p>
              <button
                onClick={() => handleSignInAndAccept()}
                className="px-4 py-2 bg-[#04b53a] text-white rounded hover:bg-[#039431] transition-colors"
              >
                Sign in with Google
              </button>
            </div>
          ) : (
            <button
              onClick={() => handleSignInAndAccept()}
              className="px-4 py-2 bg-[#04b53a] text-white rounded hover:bg-[#039431] transition-colors"
            >
              Accept Invitation
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AcceptInvitationPage; 